import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import { Link } from "react-router-dom";
import { errorToast } from "../../../Components/ToastMessage";
import axios from "axios";

const UpcomingInterviews = () => {
  const [interviews, setInterviews] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/interviews");
        if (response.data) {
          setInterviews(response.data);
        }
      } catch (error) {
        errorToast(error.message);
      }
    })();
  }, []);

  return (
    <DashboardLayout>
      <div className="bg-gray-100 h-full overflow-y-auto p-6">
        <div className="flex justify-between gap-4 flex-wrap items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            Upcoming Interviews
          </h1>
          <Link
            to="/interview-upcomming/add"
            className="bg-slate-500 text-white px-4 py-2 rounded-md hover:bg-slate-600 transition"
          >
            Add Interview
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {interviews.map((interview) => (
            <div
              key={interview._id}
              className="bg-white shadow-md rounded-lg p-6 border-t-4 border-slate-500"
            >
              <h2 className="text-xl font-semibold text-gray-700 mb-2">
                {interview.candidate.name}
              </h2>

              <p className="text-gray-600 mb-1">
                <strong>Position:</strong> {interview.position.name}
              </p>

              <p className="text-gray-600 mb-1">
                <strong>Interviewer:</strong> {interview.interviewer.name}
              </p>

              <p className="text-gray-600 mb-4">
                <strong>Date:</strong> {interview.date.split("T")[0]} <br />
                <strong>Time:</strong> {interview.time}
              </p>

              <div className="flex justify-between">
                <a
                  className="bg-slate-500 text-white px-4 py-2 rounded-md hover:bg-slate-600 transition"
                  href={`${process.env.REACT_APP_MEETING_URL}/${interview._id}?interviewer=true`}
                  target="__blank"
                >
                  Join Meeting
                </a>
                <Link
                  to={`/interview-upcomming/reschedule/${interview.id}`}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 transition"
                >
                  Reschedule
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UpcomingInterviews;
